import { render, staticRenderFns } from "./RulebookValidationTab.vue?vue&type=template&id=740b92a0&scoped=true&"
import script from "./RulebookValidationTab.vue?vue&type=script&lang=js&"
export * from "./RulebookValidationTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookValidationTab.vue?vue&type=style&index=0&id=740b92a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b92a0",
  null
  
)

export default component.exports